import React from 'react'
import PropTypes from 'prop-types'
import Row from "../../bootstrap/component/Row";
import Column from "../../bootstrap/component/Column";
import ColumnSelector from "../../form/component/ColumnSelector";

const style = {
    marginBottom: '16px',
}

const TableColumnSelector = ({ resultsNumber, columnList, hiddenColumns, toggleColumnVisibility }) => {
    return (
        <div style={style}>
        <Row>
            <Column size={6}>
                <div className="default-text number-status pb-1">
                    Displaying {resultsNumber} results
                </div>
            </Column>
            {toggleColumnVisibility && (<Column size={6} className="align-right">
                <ColumnSelector
                    title={'Columns'}
                    columnList={columnList}
                    toggleColumnVisibility={toggleColumnVisibility}
                    hiddenColumns={hiddenColumns}
                />
            </Column>)}
        </Row>
        </div>
    )
}

TableColumnSelector.propTypes = {
    columnList: PropTypes.array.isRequired,
}

export default TableColumnSelector



// WEBPACK FOOTER //
// ./src/modules/table/component/TableColumnSelector.js